import React, { useState, useEffect } from 'react';
 
import useTable from '../useTable'
import axios from 'axios';

import { Mensaje } from '../mensajes2';
import { Dimmer } from '../spinner';
import { ActualizarDireccion } from './modalActualizarDirrecion';
/* import { ActualizarDireccion } from './modalActualizarDireccion';
import { ToastsGeneral } from '../toasts'; */
import { Toasts } from '../toasts';

const headCells = [
    { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'CÓDIGO', textAlign: 'center' },
    { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'NOMBRE', textAlign: 'center' },
    { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'ENCARGADO', textAlign: 'center' },
    { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }
]

function EstructOrganizativa() {
    const [titulo1, setTitulo1] = useState();
    const [msg1, setMsg1] = useState();
    const [mostrar5, setMostrar5] = useState(false);
    const [contar4, setContar4] = useState(0);
    const [coordinacion, setCoordinacion] = useState([]);
    const [activate, setActivate] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [persona, setPersona] = useState();
    const [direccion, setDireccion] = useState();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const permiso = JSON.parse(localStorage.getItem('accestructura'))

    const [records, setRecords] = useState([]);

    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    /*     const accestorg = JSON.parse(localStorage.getItem('accestorg')) */
    const [toast, setToast] = useState({
        mostrar: false,
        mensaje: '',
        titulo: ''
    })
    const {
        TblContainer,
        TblHead,
        recordsAfterPagingAndSorting,
        TblPagination
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.iddireccion.includes(target.value)
                            || x.nombre.toUpperCase().includes(target.value.toUpperCase())
                            || x.encargado.toUpperCase().includes(target.value.toUpperCase())) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    useEffect(() => {
        seleccionarDireccion();
    }, []);


    const seleccionarDireccion = () => {
        setActivate(true);

        let campos = 'direccion.*, persona.nombres as nombreencargado, persona.apellidos';
        let nomtab = 'direccion, persona';
        let condi = "persona.cedula = direccion.encargado AND idefiscal=" + idefiscal;
        let orden = 'iddireccion';

        let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?&campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;


        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then((response) => {

            if (response.status == 200) {

                if (response.data.length > 0) {
                    setRecords(response.data);
                    console.log(response.data)
                    setContar4(contar4 + 1);
                    setActivate(false);
                } else {
                    setRecords([]);
                }
            }

            setActivate(false);

        }).catch((error) => {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response === undefined ? 'Error de Conexion' : error.response.data.message, icono: 'error' });
            setActivate(false);

        })
    };

    const SeleccionarRegistro = (id) => {
        setActivate(true);
        let campos = "*"
        let nomtab = "direccion";
        let nomid = "iddireccion";

        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                if (response.data.iddireccion > 0) {
                    setDireccion(response.data);
                    SeleccionarPersona(response.data);
                }
            }

        }).catch((error) => {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        })
    }

    const SeleccionarPersona = (data) => {

        let campos = "*"
        let nomtab = "persona";
        let nomid = "cedula";

        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.encargado}&nomtab=${nomtab}&nomid=${nomid}`

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                if (response.data.cedula > 0) {
                    setPersona(response.data);
                    SeleccionarCoordinacion(data.iddireccion);
                } else {
                    setPersona()
                    SeleccionarCoordinacion(data.iddireccion);
                }
            }

        }).catch((error) => {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        })
    }

    const SeleccionarCoordinacion = (id) => {

        let endpoint = `${op.conexion}/api/configuracion/consultacoordinacion?id=${id}`;

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then((response) => {

            if (response.status == 200) {

                if (response.data.length > 0) {

                    setCoordinacion(response.data);
                    setMostrar5(true);
                } else {
                    setCoordinacion([]);
                    setMostrar5(true);
                }
                setActivate(false);
            }


        }).catch((error) => {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        })

    }


    const gestionarDireccion = (op, id, per) => (e) => {
        e.preventDefault()

        if (per.toString() === '1') {
            setOperacion(op)


            if (op === 4) {
                /*  if(accestorg.substring(0,1) !== '0'){ */
                SeleccionarRegistro(id);
                /*  }  else {
                 setToast({... toast ,mostrar:true, titulo:'Notificación', mensaje:'No Posee los Permisos para Realizar esta Acción'})
               } */

            } else if (op === 1) {
                /*    if(accestorg.substring(1,2) !== '0'){ */

                setMostrar5(true)
                /*  } else {
                   setToast({... toast ,mostrar:true, titulo:'Notificación', mensaje:'No Posee los Permisos para Realizar esta Acción'})
                 }
          */
            } else if (op === 2) {
                /*   if(accestorg.substring(2,3) !== '0'){ */
                SeleccionarRegistro(id);
                /*             } else{
                              setToast({... toast ,mostrar:true, titulo:'Notificación', mensaje:'No Posee los Permisos para Realizar esta Acción'})
                            
                            } */

            } else if (op === 3) {
                /* if(accestorg.substring(3,4) !== '0'){ */
                SeleccionarRegistro(id);

                /*    } else{
                      setToast({... toast ,mostrar:true, titulo:'Notificación', mensaje:'No Posee los Permisos para Realizar esta Acción'})
                   } */

            }
        } else {
            setToast({
                mostrar: true,
                mensaje: op === 1 ? 'No posee permiso para Registrar' : op === 2 ? 'No posee permiso para Editar' : op === 3 ? 'No posee permiso para Eliminar' : 'No posee permiso para Consultar',
                titulo: 'Alerta.'
            })
        }

    }

    const cerrarToast = () => {
        setToast({
            mostrar: false
        })
    }

    const handleCancela2 = () => {
        setMostrar5(false);
    }


    return (
        <div className="h-100 w-100 p-0 m-0">


            <div className="container">
                <div className="content">
                    <div className="card px-3 py-2">
                        <div className="col-md-12 row m-0 py-1">
                            <div className="col-md-2">
                                <input type="text" className="form-control search-input form-control-sm rounded-pill" onChange={handleSearch} placeholder="Buscar" />
                            </div>

                            <div className="col-md-1 ml-auto">
                                <button onClick={gestionarDireccion(1, '',permiso.toString().substring(1, 2))} style={{ marginBottom: "5px" }} className={permiso.toString().substring(1, 2) === '1' ? 'btn btn-sm btn-primary rounded-pill' : 'btn btn-sm btn-secondary rounded-pill'}><i className="fas fa-plus"></i> </button>
                            </div>

                        </div>
                        <div className="col-md-12">
                            <TblContainer >
                                <TblHead />

                                <tbody>
                                    {

                                        records && recordsAfterPagingAndSorting().map((item, index) => (
                                            <tr key={index} style={{ padding: "0" }}>
                                                <td className='align-baseline' style={{ textAlign: "center", width: "50px" }}>{item.iddireccion}</td>
                                                <td className='align-baseline' style={{ textAlign: "center", width: "350px" }}>{item.nombre}</td>
                                                <td className='align-baseline' style={{ textAlign: "center", width: "100px" }}>{item.nombreencargado + ' ' + item.apellidos}</td>

                                                <td className='align-baseline' style={{ textAlign: "center", width: '90px' }}>
                                                    <button onClick={gestionarDireccion(4, item.iddireccion,permiso.toString().substring(0, 1))} className={permiso.toString().substring(0, 1) === '1' ? 'btn btn-sm btn-info rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'}><i className="fas fa-eye"></i> </button>
                                                    <button onClick={gestionarDireccion(2, item.iddireccion,permiso.toString().substring(2, 3))} className={permiso.toString().substring(2, 3) === '1' ? 'btn btn-sm btn-warning rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'}><i className="fa fa-edit"></i> </button>
                                                    <button onClick={gestionarDireccion(3, item.iddireccion,permiso.toString().substring(3, 4))} className={permiso.toString().substring(3, 4) === '1' ? 'btn btn-sm btn-danger rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'
                                                }><i className="fa fa-trash"></i> </button>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>

                            </TblContainer>
                            <TblPagination />

                        </div>
                    </div>
                </div>
            </div>
            <Toasts
                show={toast.mostrar}
                titulo={toast.titulo}
                mensaje={toast.mensaje}
                onHideCancela={cerrarToast}
            />

            <ActualizarDireccion
                show={mostrar5} titulo={titulo1} mensaje={msg1}
                operacion={operacion}
                persona={persona}
                direccion={direccion}
                coordinacion={coordinacion}
                onHideRender={SeleccionarRegistro}
                onHideCancela={handleCancela2} onHideRenderizar={seleccionarDireccion}
            />

            
<Dimmer active={activate} inverted>
       
      </Dimmer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />
        </div >

    );

}

export default EstructOrganizativa;